module.exports = __webpack_public_path__ + "img/icon-search.37745a43.svg";